/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AmenityCategory = {
    AirportShuttle: 'Airport Shuttle',
    AllInclusivePackages: 'All Inclusive Packages',
    FitnessCenter: 'Fitness Center',
    FreeBreakfast: 'Free Breakfast',
    Parking: 'Parking',
    PetFriendly: 'Pet Friendly',
    Pool: 'Pool',
    Restaurant: 'Restaurant',
    RoomService: 'Room Service',
    Snacks: 'Snacks',
    Spa: 'Spa'
} as const;
export type AmenityCategory = typeof AmenityCategory[keyof typeof AmenityCategory];


export function instanceOfAmenityCategory(value: any): boolean {
    for (const key in AmenityCategory) {
        if (Object.prototype.hasOwnProperty.call(AmenityCategory, key)) {
            if (AmenityCategory[key as keyof typeof AmenityCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AmenityCategoryFromJSON(json: any): AmenityCategory {
    return AmenityCategoryFromJSONTyped(json, false);
}

export function AmenityCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AmenityCategory {
    return json as AmenityCategory;
}

export function AmenityCategoryToJSON(value?: AmenityCategory | null): any {
    return value as any;
}

export function AmenityCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): AmenityCategory {
    return value as AmenityCategory;
}

